import { render, staticRenderFns } from "./SubscribePlanCard.vue?vue&type=template&id=3106aa5d&scoped=true&"
import script from "./SubscribePlanCard.vue?vue&type=script&lang=js&"
export * from "./SubscribePlanCard.vue?vue&type=script&lang=js&"
import style0 from "./SubscribePlanCard.vue?vue&type=style&index=0&id=3106aa5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3106aa5d",
  null
  
)

export default component.exports